module.exports = __webpack_public_path__ + "static/img/menu-product-h30.b2d12ce0.png";